<!-- Modal -->
<app-toaster style="z-index: 10000;" *ngIf="showToast" [message]="toastMessage" [type]="toastType"></app-toaster>

<div class="modal fade" id="changeEmail" tabindex="-1" aria-labelledby="changeEmailModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="membershipModalLabel">

                    {{ ("PROFILE.CHANGE_EMAIL"|translate)}}
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeMembershipModal()"></button>
            </div>
            <div class="modal-body">


                <!-- Apply for membership Form -->
                <!-- @if(membershipStatus === 'Rejected' || membershipStatus === 'Applied' ||
                membershipStatus === ''|| membershipStatus === 'None'){ -->

                <div class="card">
                    <div class="card-body">

                        <form method="post" name="enq" [formGroup]="EmailForm" (ngSubmit)="onSubmit()">
                            <div class="row">

                                <div class="name-email">
                                    <div class="col-12 my-3">
                                        <input type="email" formControlName="currentEmail" readonly
                                            [placeholder]="'CONFIRMATION.CURRENT_EMAIL' | translate"
                                            name="currentEmail">
                                        <div class="text-danger mb-4"
                                            *ngIf="f['currentEmail'].touched && f['currentEmail'].invalid">
                                            <div *ngIf="f['currentEmail'].errors?.['required']">
                                                {{"REGISTER.EMAILREQUIRED"|translate}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="name-email">
                                    <div class="col-12 my-3">
                                        <input type="email" formControlName="newEmail"
                                            [placeholder]="'CONFIRMATION.NEW_EMAIL' | translate" name="newEmail">
                                        <div class="text-danger mb-4"
                                            *ngIf="f['newEmail'].touched && f['newEmail'].invalid">
                                            <div *ngIf="f['newEmail'].errors?.['required']">
                                                {{"REGISTER.EMAILREQUIRED"|translate}}</div>
                                            <div *ngIf="f['newEmail'].errors?.['pattern']">
                                                {{"REGISTER.EMAILVALIDATION"|translate}}</div>
                                        </div>
                                    </div>
                                </div>

                                @if(isSentCode){
                                <div class="name-email my-3">
                                    <div class="col-12">
                                        <input type="text" formControlName="verificationCode"
                                            [placeholder]="'CONFIRMATION.VERFICATION_CODE' | translate"
                                            name="verificationCode">
                                        @if( EmailForm.get("verificationCode")?.errors &&
                                        EmailForm.get("verificationCode")?.touched){
                                        <div class="text-danger mb-4">
                                            @if (EmailForm.get("verificationCode")?.errors?.["required"]) {
                                            <div>
                                                {{"CONFIRMATION.CODE_REQUIRED"|translate}}
                                            </div>
                                            }
                                            @else {
                                            <div>
                                                {{"CONFIRMATION.CODE_INVALID"|translate}}
                                            </div>
                                            }

                                        </div>
                                        }
                                    </div>
                                </div>

                                <div class="col-md-12 contact-form-style-2">
                                    <button type="submit" class="btn btn-fill-out submit font-weight-bold" name="submit"
                                        value="Submit" data-bs-dismiss="modal">
                                        {{"PROFILE.SUBMIT" | translate}}</button>
                                </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
                <!-- } -->

            </div>
        </div>
    </div>
</div>